import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import FacetWP from './modules/FacetWP.js';
import Columns from './modules/Columns.js';

document.addEventListener('DOMContentLoaded', function () {
  Navigation();
  MobileNavigation();
  Columns();
  FacetWP();

  // Remove tabindex="-1" from language switcher options to make it keyboard accessible
  const languageOptions = document.querySelectorAll('.trp-language-switcher [tabindex="-1"]');
  languageOptions.forEach((option) => {
    option.setAttribute('tabindex', '0');
  });

  // Make Enter key work on language options (excluding current language)
  const languageLinks = document.querySelectorAll(
    '.trp-language-item:not(.trp-language-item__current)'
  );
  languageLinks.forEach((link) => {
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Add accessible name to language switcher listbox
  const languageSwitchers = document.querySelectorAll('.trp-language-switcher[role="listbox"]');
  languageSwitchers.forEach((switcher) => {
    if (!switcher.hasAttribute('aria-label') && !switcher.hasAttribute('aria-labelledby')) {
      switcher.setAttribute('aria-label', 'Language switcher');
    }
  });
});
